import Vue from 'vue'
import Router from 'vue-router'
import GMap from "@/components/home/GMap";
import SignUp from "@/components/auth/SignUp";
import Login from "@/components/auth/Login";
import ViewProfile from "@/components/profile/ViewProfile";
import Firebase from 'firebase'

Vue.use(Router)

const router =  new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'GMap',
            component: GMap
            //meta: {
              //  requiresAuth:true
            //}
        },
        {
            path: '/signup',
            name: 'SignUp',
            component: SignUp
            //meta: {
             //   requiresAuth:true
            //}
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/profile/:id',
            name: 'ViewProfile',
            component: ViewProfile
          // meta: {
            //   requiresAuth:true
            //}-->
        }
    ]
})

router.beforeEach((to, from, next) =>{
        //check to see if route requires auth
    if(to.matched.some(rec=>rec.meta.requiresAuth)) {
        //check stat of user
        let user = Firebase.auth().currentUser
        if (user) {
            next()
        } else {
            //no user signin, then redirect to login
            next({name: 'Login'})
        }
    } else{
            next()
        }
    })

export default router

